// frontend/src/api/retention.js
import { apiClient } from './index';

const retentionApi = {
  getDueVehicles: async () => {
    return await apiClient.get('/retention/due');
  },

  sendReminder: async (vehicleId) => {
    return await apiClient.post(`/retention/remind/${vehicleId}`);
  },

  // --- NEW METHODS ---
  getSettings: async () => {
      return await apiClient.get('/retention/settings');
  },

  updateSettings: async (data) => {
      return await apiClient.put('/retention/settings', data);
  },

  runAutoPilot: async () => {
      return await apiClient.post('/retention/auto-run');
  }
};

export { retentionApi };